module.exports = __webpack_public_path__ + "static/media/attack-number-4.b3c52080.png";